import { render, staticRenderFns } from "./SetPass.vue?vue&type=template&id=7c49f515&scoped=true"
import script from "./SetPass.vue?vue&type=script&lang=js"
export * from "./SetPass.vue?vue&type=script&lang=js"
import style0 from "./SetPass.vue?vue&type=style&index=0&id=7c49f515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c49f515",
  null
  
)

export default component.exports